import React from 'react';
import { RiTextDirectionL, RiTextDirectionR } from 'react-icons/ri';
import s from './LanguageSelect.module.scss';
export const LANGUAGE_OPTIONS = [
    {
        value: 'he-rtl',
        language: 'he',
        direction: 'rtl',
        label: (React.createElement("span", { className: s.optionContent },
            "\u05E2\u05D1\u05E8\u05D9\u05EA ",
            React.createElement(RiTextDirectionR, null))),
    },
    {
        value: 'he-ltr',
        language: 'he',
        direction: 'ltr',
        label: (React.createElement("span", { className: s.optionContent },
            React.createElement(RiTextDirectionL, null),
            " \u05E2\u05D1\u05E8\u05D9\u05EA")),
    },
    { value: 'en-ltr', language: 'en', direction: 'ltr', label: 'English' },
    { value: 'ro-ltr', language: 'ro', direction: 'ltr', label: 'Română' },
    { value: 'uk-ltr', language: 'uk', direction: 'ltr', label: 'Українська' },
];
export const orderOptions = (options, envDefaultLanguage) => {
    const def = [];
    const eng = [];
    const rest = [];
    for (const opt of options) {
        if (opt.language === envDefaultLanguage)
            def.push(opt);
        else if (opt.language === 'en')
            eng.push(opt);
        else
            rest.push(opt);
    }
    return [...def, ...eng, ...rest];
};
